import React, { useState } from 'react';
import { InputAdornment, TextFieldProps } from '@material-ui/core';
import InputTextField from './TextField';
import IconButton from '@material-ui/core/IconButton';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';

interface Props {
  errors?: any;
  label?: string;
  name?: string;
  TextFieldProps?: Partial<TextFieldProps>;
}

//TODO: need to add to storybook
export default function PasswordInputField({
  errors = {},
  label,
  name,
  TextFieldProps,
}: Props) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <InputTextField
      errors={errors}
      type={showPassword ? 'text' : 'password'}
      label={label}
      name={name}
      TextFieldProps={TextFieldProps}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="Toggle password visibility"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
